module.exports = __webpack_public_path__ + "static/media/cancelada__iconeye.2bfe41f7.svg";